export const enableSoundsStorageName = '_ss.enableSounds'
